export const GTM_EVENTS = {
  PAGE_VIEW: 'virtual_pv',
  CUSTOM_EVENT: 'custom_event',
};

export const GTM_EVENT_CATEGORIES = {
  FILTERING: 'filtering',
  CLICK: 'click',
};

export const GTM_EVENT_ACTIONS = {
  NAVIGATION_CLICK: 'navigation_click',
  FILTERS_APPLIED: 'filters_applied',
};
